import createReducer from 'utils/createReducer';

const INIT_STATE = {
  mapBounds: null,
  mainMarker: null,
};

const SET_MAP_BOUNDS = 'point-of-interest/map/SET_MAP_BOUNDS';
const SET_MAP_MAIN_MARKER = 'point-of-interest/map/SET_MAP_MAIN_MARKER';
const SET_CLEAR = 'point-of-interest/map/SET_CLEAR';

const reducer = createReducer(INIT_STATE, {
  [SET_MAP_BOUNDS](state, payload) {
    return {
      ...state,
      mapBounds: payload.mapBounds,
    };
  },
  [SET_MAP_MAIN_MARKER](state, payload) {
    return {
      ...state,
      mainMarker: payload.mainMarker,
    };
  },
  [SET_CLEAR]() {
    return INIT_STATE;
  },
});

const setMapBounds = (mapBounds) => ({
  type: SET_MAP_BOUNDS,
  payload: { mapBounds },
});

const setMainMarker = (mainMarker) => ({
  type: SET_MAP_MAIN_MARKER,
  payload: { mainMarker },
});

const setClear = () => ({
  type: SET_CLEAR,
  payload: {},
});

export default reducer;
export { INIT_STATE, setMapBounds, setMainMarker, setClear };
